import { booleanAttribute, Component, ElementRef, inject, Input, OnDestroy } from "@angular/core";
import { MatIcon } from "@angular/material/icon";

@Component({
    selector: "cerrix-icon-button",
    imports: [MatIcon],
    templateUrl: "./cerrix-icon-button.component.html",
    styleUrl: "./cerrix-icon-button.component.scss",
})
export class CerrixIconButtonComponent implements OnDestroy {
    @Input({ required: true }) icon: string;
    @Input({ required: true }) ariaLabel: string;
    @Input({ transform: booleanAttribute }) showBorder = true;
    @Input({ transform: booleanAttribute }) disabled = false;
    /** `medium` is the design system's icon button: 32px with a 24px icon. `small` is 20px with a 20px icon. */
    @Input() buttonSize: "medium" | "small" = "medium";

    private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

    constructor() {
        this.elementRef.nativeElement.addEventListener("click", this.haltDisabledEvents, true);
    }

    ngOnDestroy(): void {
        this.elementRef.nativeElement.removeEventListener("click", this.haltDisabledEvents, true);
    }

    // Capture before Angular's coalesced host/caller listeners can invoke the action.
    private readonly haltDisabledEvents = (event: Event): void => {
        if (this.disabled) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
        }
    };
}
